






















































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import {
  fontFaceList,
  fontSizeOptions,
  rgbaBackgroundPredefineColors,
} from '../../../constant/options';
import {
  getIconImageList
} from "@/services/api";
import { getCompanyInfo } from "@/model/CompanyInfo";
import { getFontFaceList } from "@/utils/getFontFaceList";
import { getVueAppUploadApi } from "@/services/util";
import { ensureFileScopeAuthorized } from "@/services/fileScope";
import { popupImageBeforeUpload } from "@/utils/popupImageCompression";
import { isEnableIconCapabilityOptimize } from "@/utils/experiment";
import {
  ICON_CLOSE_SIZE_OPTIONS,
  ICON_CLOSE_POSITION_OPTIONS,
  DEFAULT_ICON_CLOSE_COLOR,
  DEFAULT_ICON_CLOSE_BG_COLOR,
  getSquareIconWidth,
  resolveDisplayIconCloseSize,
  resolveIconClosePosition,
} from "@/utils/iconPackUp";


@Component({
  components: {
    "yc-color-picker": YcColorPicker,
  },
})
export default class wheelOfFortuneTextPackUp extends Vue {
  @Prop(String)
  activePageSetting!:string;

  @Prop(Object)
  formData!:object;

  imageDialogVisible = false;
  selectImageUrl: string = '';
  imageList: { id: number, imageName: string, imageUrl: string }[] = [];

  formDataStart: any = this.formData

  imgNameArr = [
    { imgName: 'left_top_', top: '20px', left: '20px' },
    { imgName: 'right_top_', top: '20px', right: '20px' },
    { imgName: 'left_center_', top: '47%', left: '20px' },
    { imgName: 'right_center_', top: '47%', right: '20px' },
    { imgName: 'left_bottom_', bottom: '20px', left: '20px' },
    { imgName: 'right_bottom_', bottom: '20px', right: '20px' }
  ]
  imgNameObjArr =[
    "LeftTop","RightTop", "LeftMiddle", "RightMiddle", "LeftBottom", "RightBottom"
  ]
  get iconSizeOption() {
    return [
      { label: this.$tx('form.edit.field.sizeS', '小'), value: 'Small' },
      { label: this.$tx('form.edit.field.sizeM', '中'), value: 'Medium' },
      { label: this.$tx('form.edit.field.sizeL', '大'), value: 'Big' },
    ]
  }
  iconClosePositionOptions = ICON_CLOSE_POSITION_OPTIONS
  iconCloseSizeOptions = [...ICON_CLOSE_SIZE_OPTIONS]
  defaultIconCloseColor = DEFAULT_ICON_CLOSE_COLOR
  defaultIconCloseBgColor = DEFAULT_ICON_CLOSE_BG_COLOR
  iconClosePredefineColors = rgbaBackgroundPredefineColors

  selectImgVis = 1

  uploadUrl = getVueAppUploadApi() + "/upload/formImage";

  uploadShow = false;

  uploadFileList: {name: string, url: string}[] = [];

  uploadDialogVisible = false;

  uploadDialogUrl = '';

  get token() {
    return localStorage.getItem("token") || "default";
  }

  predefineColors = [
    '#ff4500',
    '#ff8c00',
    '#ffd700',
    '#90ee90',
    '#00ced1',
    '#1e90ff',
    '#c71585',
    '#f1b859',
    '#f4994b',
    '#d7394d',
    '#dd5b46',
    '#f7d69e',
  ]

  bannerImgNameArr = ['banner_top_', 'banner_bottom_']

  selectBannerImgVis = 1

  fontFaceList = getFontFaceList(fontFaceList);
  fontSizeOptions = fontSizeOptions;

  activeNames = 1
  handleChange(){}

  get enableFormOptimize() {
    return true;
  }

  get enableIconCapabilityOptimize() {
    return isEnableIconCapabilityOptimize();
  }

  get displayIconClosePosition() {
    const position = this.formDataStart?.settings?.position || {};
    return resolveIconClosePosition(position.position, position.iconClosePosition);
  }

  get displayIconCloseSize() {
    const position = this.formDataStart?.settings?.position || {};
    const boxW = Number(position.iconWidth) || getSquareIconWidth(position.iconSizeType);
    return resolveDisplayIconCloseSize(position, boxW, this.iconCloseSizeOptions);
  }

  handleSelectIcon() {
    // console.log(this.selectImageUrl);
    if (this.selectImageUrl) {
      this.formDataStart?.settings?.position && (this.formDataStart.settings.position.iconUrl = this.selectImageUrl);
      this.uploadFileList = [{
        name: '',
        url: this.selectImageUrl
      }];
    }
    this.imageDialogVisible = false;
    // console.log('handleSelectIcon');
  }


  /**
   * banner图片切换
   */
   selectBannerImgClick(index: number){
    this.formDataStart.settings.banner.position = ['top', 'bottom'][index]
    this.selectBannerImgVis = index + 1
    this.$emit('change',this.formDataStart)
  }
  
  openBanner(){
    // 转盘有coupon
    // if(!this.formDataStart.settings.rules.couponCodeShow || !this.formData.settings.rules.couponCodePosition){
    //   this.formDataStart.settings.banner.bannerShow = false
    //   this.$message({
    //     message: '需开启展示Coupon功能才可使用',
    //     type: 'warning'
    //   });
    // }
    this.changeStart();
    window?.gtagClick('form_tool_collapseBanner','弹窗_编辑订阅工具_收起_修改横幅')
  }

  countDownChange() {
    if (this.formDataStart.settings.banner.countDownNum < 1) {
      this.formDataStart.settings.banner.countDownNum = 1;
    } else if (this.formDataStart.settings.banner.countDownNum > 60) {
      this.formDataStart.settings.banner.countDownNum = 60;
    }
    this.changeStart();
  }

  created() {
    if (this.formDataStart.settings.position.iconSizeType) {
      switch (this.formDataStart.settings.position.iconSizeType) {
      case 'Small':
        this.formDataStart.settings.position.iconWidth = 30;
        // Vue.set(this.formData.settings.position, 'iconWidth', '30px')
        break;
      case 'Medium':
        this.formDataStart.settings.position.iconWidth = 50;
        // Vue.set(this.formData.settings.position, 'iconWidth', '50px')
        break;
      case 'Big':
        this.formDataStart.settings.position.iconWidth = 80;
        // Vue.set(this.formData.settings.position, 'iconWidth', '80px')
        break;
      default:
        this.formDataStart.settings.position.iconWidth = 50;
        // Vue.set(this.formData.settings.position, 'iconWidth', '30px')
        break;
    }
    }
    this.formDataStart.settings.position.iconSizeType = this.formDataStart.settings.position.iconSizeType ?? 'Medium'
    this.formDataStart.settings.position.iconShow = Boolean(this.formDataStart.settings.position.iconShow) ?? true
    // this.formDataStart.settings.position.iconWidth = this.formDataStart.settings.position.iconWidth ? this.formDataStart.settings.position.iconWidth : '50px';


    if(this.formDataStart.settings.banner.position == 'top'){
      this.selectBannerImgVis = 1
    }else{
      this.selectBannerImgVis = 2
    }

    if (this.formData.settings.position.iconUrl) {
      this.uploadShow = true
      this.uploadFileList  = [
        {
          name:'',
          url:this.formData.settings.position.iconUrl,
        }
      ]
    }
    this.selectImgVis = this.imgNameObjArr.indexOf(this.formData.settings.position.position) + 1

    // 确保iconExcludePages是数组
    if (!this.formDataStart.settings.targeting.iconExcludePages) {
      this.$set(this.formDataStart.settings.targeting, 'iconExcludePages', []);
    }

    // 请求icon列表
    getIconImageList({}).then((res: any) => {
      this.imageList = res.data.data;
    });

    this.$forceUpdate();
    this.$emit('change',this.formDataStart)
  }

  /**
   * 图片上传失败钩子函数
   */
  handleError(e: any): void {
    this.uploadShow = false;
    this.$message.warning(this.$tx('form.edit.err.uploadFail', '图片上传失败！'));
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert(this.$tx('form.edit.err.loginExpired', '登录失效，请重新登录'));
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect='+ encodeURIComponent(this.$router.currentRoute.fullPath)
    }
    this.changeStart()
  }

  changeIconCustom() {
    if (this.formDataStart.settings.position.iconCustom) {
      const isMiddle = ['LeftMiddle', 'RightMiddle'].includes(this.formDataStart.settings.position.position);
      const isTop = ['LeftTop', 'RightTop'].includes(this.formDataStart.settings.position.position);
      if (!isTop) {
        this.formDataStart.settings.position.iconCustomBottom = isMiddle ? 50 : 100;
      }
      this.formDataStart.settings.position.iconCustomBottomUnit = isMiddle ? '%' : 'px';
    } else {
      this.formDataStart.settings.position.iconCustomBottom = undefined;
      this.formDataStart.settings.position.iconCustomBottomUnit = undefined;
    }
    this.reportIconCustomClick();
    this.changeStart()
  }

  // icon 可关闭
  changeIconClose(val: boolean) {
    this.formDataStart.settings.position.iconClose = val;
    this.changeStart();
  }

  changeIconClosePosition(val: string) {
    this.setIconPositionField('iconClosePosition', val);
  }

  changeIconCloseStyle(val: 'outside' | 'inside') {
    this.setIconPositionField('iconCloseStyle', val);
  }

  changeIconCloseSize(val: number) {
    this.setIconPositionField('iconCloseSize', val);
  }

  changeIconCloseColor(val: string) {
    this.setIconPositionField('iconCloseColor', val);
  }

  changeIconCloseBgColor(val: string) {
    this.setIconPositionField('iconCloseBgColor', val);
  }

  setIconPositionField(key: string, val: any) {
    this.$set(this.formDataStart.settings.position, key, val);
    this.changeStart();
  }

  reportIconCustomClick() {
    window?.gtagClick('form_edit_setIcon_spacing','弹窗_编辑订阅工具_设置icon_间距设置');
  }

    /**
   * 图片切换
   */
  selectImgClick(index: number) {
    this.formDataStart?.settings?.position && (
      this.formDataStart.settings.position.position = ['LeftTop', 'RightTop', 'LeftMiddle', 'RightMiddle', 'LeftBottom', 'RightBottom'][index]
    );
    this.selectImgVis = index + 1
    this.$emit('change',this.formDataStart)
  }

  /**
   * 图片上传成功钩子函数
   */
  handleSuccess(
    res: { data: { url: string, message:string }[] },
    file: any,
    fileList: any
  ): void {
    this.uploadShow = true;

    if(res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.position && (this.formDataStart.settings.position.iconUrl = res.data[0].url);
      this.uploadFileList = res.data[0].url ? [{name: '', url: res.data[0].url}]: []
      this.$forceUpdate()
    } else {
      fileList.splice(0, fileList.length);
      this.uploadShow = false;
      this.$message.warning(this.$failMsg(res.data[0].message));
    }

    this.changeStart()

  }

  /**
   * 图片上传前钩子函数
   */
  beforeUpload(file: File): Promise<File | Blob | boolean> {
    return popupImageBeforeUpload(file, this.$message).then((uploadFile) => {
      if (!uploadFile) {
        return false;
      }
      // 新增需求：图片压缩通过后仍需保留上传授权校验。
      return ensureFileScopeAuthorized().then(() => {
        this.uploadShow = true;
        return uploadFile;
      });
    });
  }
  /**
   * 删除图片
   */
  uploadUrlDelete() {
    this.uploadShow = false;
    this.formDataStart?.settings?.position && (this.formDataStart.settings.position.iconUrl = '');
  }
  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }


  changeStart() {
    switch (this.formDataStart.settings.position.iconSizeType) {

      case 'Small':
        this.formDataStart.settings.position.iconWidth = 30;
        // Vue.set(this.formData.settings.position, 'iconWidth', '30px')
        break;
      case 'Medium':
        this.formDataStart.settings.position.iconWidth = 50;
        // Vue.set(this.formData.settings.position, 'iconWidth', '50px')
        break;
      case 'Big':
        this.formDataStart.settings.position.iconWidth = 80;
        // Vue.set(this.formData.settings.position, 'iconWidth', '80px')
        break;
      default:
        this.formDataStart.settings.position.iconWidth = 50;
        // Vue.set(this.formData.settings.position, 'iconWidth', '30px')
        break;
    }
    this.$forceUpdate();
    this.$emit('change',this.formDataStart)
  }
  @Watch('formData.settings.position.position')
  positionChange(){
    // console.log(this.imgNameObjArr.indexOf(this.formData.settings.position.position) +1)
    this.selectImgVis = this.imgNameObjArr.indexOf(this.formData.settings.position.position) +1
  }

  validateNumberInput() {
    try {
      const newVal = parseInt(this.formDataStart.settings.position.iconCustomBottom.toString().replace(/[^\d]/g, ''), 10);
      // 兼容element input 数字0校验异常
      this.formDataStart.settings.position.iconCustomBottom = newVal === 0 ? '0' : newVal;
    } catch (e) {
      console.log('validateNumberInput error', e);
    }
    // this.changeStart();
  }

}
